import { ReactNode } from 'react';

export interface IColumnSetting<T extends string = string> {
  isActive?: boolean;
  children?: Partial<Record<T, IColumnSetting<T>>>;
}

export type TColumnConfig<T extends string> = Partial<Record<T, IColumnSetting<T>>>;

export type TRowType<T extends string> = Record<T, ReactNode>;

export function getConfigKey<T extends string>(config?: IColumnSetting<T>, key?: T): boolean {
  return config?.children?.[key]?.isActive ?? true;
}

export function createMandatoryColumnConfig<T extends string>(
  allConfig: TColumnConfig<T>,
  optionalColumns: T[],
): TColumnConfig<T> {
  return Object.fromEntries(
    Object.entries(allConfig).filter(([key]) => !optionalColumns.includes(key as T)),
  ) as TColumnConfig<T>;
}
